var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('loader',{staticClass:"loader"}):[_c('router-view'),_c('cookie-banner')],_c('app-notification-container'),_c('register-tooltip')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }